import { render, staticRenderFns } from "./robot-filter.vue?vue&type=template&id=8d768ba8"
import script from "./robot-filter.vue?vue&type=script&lang=js"
export * from "./robot-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports